
import { Union, FSharpRef } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { iterate, cons, empty } from "./fable_modules/fable-library-js.5.0.0-alpha.22/List.js";
import { union_type, lambda_type, unit_type } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";

export class BrowserEvent extends Union {
    constructor(startUpdate) {
        super();
        this.tag = 0;
        this.fields = [startUpdate];
    }
    cases() {
        return ["UpdateAvailable"];
    }
    static get subscribers() {
        return new FSharpRef(empty());
    }
    static subscribe(handler) {
        BrowserEvent.subscribers.contents = cons(handler, BrowserEvent.subscribers.contents);
    }
    static notify(event) {
        iterate((handler) => {
            handler(event);
        }, BrowserEvent.subscribers.contents);
    }
    static notifyUpdateAvailable(startUpdate) {
        BrowserEvent.notify(new BrowserEvent(startUpdate));
    }
}

export function BrowserEvent_$reflection() {
    return union_type("MatheApp.UI.Helpers.BrowserEvent", [], BrowserEvent, () => [[["startUpdate", lambda_type(unit_type, unit_type)]]]);
}

